import { AxiosInstance } from 'axios'

import { Consent } from '@modules/consents/types/Consents/consents'
import { CreateConsentRequest } from '@modules/consents/types/Consents/requests'

export class ConsentsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateConsentRequest): Promise<Consent> {
    const response = await this.instance.post(`/consents`, data)

    return response.data
  }

  async get(): Promise<Consent> {
    const response = await this.instance.get(`/consents`)

    return response.data
  }
}

export const consentsService = (instance: AxiosInstance) => new ConsentsService(instance)
